import { render, staticRenderFns } from "./AssetsCardTable.vue?vue&type=template&id=2d69fb9c"
import script from "./AssetsCardTable.vue?vue&type=script&lang=js"
export * from "./AssetsCardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports